// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__qOEDR","header":"ClearentDisclaimer_header__uOQPU","inner":"ClearentDisclaimer_inner__34UfL"};